<template lang="pug">
  app-layout
    v-flex(xs12)
      v-container.py-0.elevation-1.white(fluid)
        v-tabs(slider-color='primary')
          ld-gated-tab(
            v-for="item in items"
            :key="item.route.name"
            :to="item.route"
            :feature="item.feature"
          ) {{ item.text }}
          v-tab(
            v-if="landingPagesAddon"
            :to="{ name: 'landing-pages' }"
          ) Landing Pages
          v-spacer.grow
          ld-how-it-works(
            :feature="routeNameMeta"
          )
      slot
</template>

<script>
import { LdGatedTab, LdFeatures, LdHowItWorks } from 'lion-vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    LdGatedTab,
    LdHowItWorks,
  },
  mounted() {
    this.getUserAddons();
  }, 
  computed: {
    ...mapGetters('payment', ['landingPagesAddon']),
    routeNameMeta() {
      return this.$route.meta.howToVideoFeature;
    },
  },
  methods: {
    ...mapActions('payment', ['getUserAddons']),
  },
  data() {
    return {
      items: [
        { route: { name: 'campaigns' }, text: 'Campaigns' },
        { route: { name: 'published-campaigns' }, text: 'Published Campaigns' },
        { route: { name: 'templates' }, text: 'Templates', feature: LdFeatures.Templates },
      ],
    };
  },
};
</script>
